import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getEmpAllowanceDeduction = async ({
  companyCode,
  departmentCode = 0,
  employeeCode = 0,
  locationCode = "",
  type = "Addition",
  typeCode = 0,
  code = 0,
  fromDate = "",
  toDate = "",
  userId = 0,
  isAllCompanies = false,
  selectedCompanyCode = "",
}) => {
  let queryString = `?CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}&Code=${code}&FromDate=${fromDate}&ToDate=${toDate}`;

  if (departmentCode) {
    queryString += `&DepartmentCode=${departmentCode}`;
  }

  if (employeeCode) {
    queryString += `&EmployeeCode=${employeeCode}`;
  }

  if (type) {
    queryString += `&Type=${type}`;

    if (typeCode) {
      queryString += `&TypeCode=${typeCode}`;
    }
  }

  if (isAllCompanies && userId) {
    queryString += `&UserId=${userId}`;
  }

  const { data } = await http_payroll.get(
    `${isAllCompanies ? Api_EndPoints.AllCompanies_GetEmpPayrollAdditionandDeductions : Api_EndPoints.GetEmpPayrollAdditionandDeductions}${queryString}`,
  );
  return data;
};

export const useGetEmpAdditionDeductionQuery = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);

  return useQuery({
    queryKey: [
      isAllCompanies
        ? Api_EndPoints.AllCompanies_GetEmpPayrollAdditionandDeductions
        : Api_EndPoints.GetProjectAdditionandDeductionsReport,
      input,
    ],
    queryFn: () => getEmpAllowanceDeduction(input),
    refetchOnWindowFocus: false,
  });
};

const addAddition = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.EmployeePayrollAdditionAndDeductionCreation,
    input,
  );
  return data;
};

const importAllowanceAndDeduction = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.ImportEmpAllowanceAndDeduction,
    input,
  );
  return data;
};

const getDefaultEmpAllowanceDeduction = async (input) => {
  if (
    input.companyCode &&
    input.locationCode &&
    input.fromDate &&
    input.toDate
  ) {
    let queryString = `?CompanyCode=${input.companyCode}&LocationCode=${input.locationCode}&FromDate=${input.fromDate}&ToDate=${input.toDate}`;

    if (input.salaryType !== "") {
      queryString += `&SalaryType=${input.salaryType}`;
    }
    const { data } = await http_payroll.get(
      `${Api_EndPoints.GetDefaultAllowanceList}${queryString}`,
    );
    return data;
  }

  return false;
};

export const useImportEmpAllowanceDeductionMutation = () => {
  return useMutation({
    mutationFn: importAllowanceAndDeduction,
  });
};

export const useAddEmpAllowanceDeductionMutation = () => {
  return useMutation({
    mutationFn: addAddition,
  });
};

const updateAddition = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.EmployeePayrollAdditionAndDeductionUpdate,
    input,
  );
  return data;
};

export const useUpdateEmpAllowanceDeductionMutation = () => {
  return useMutation({
    mutationFn: updateAddition,
  });
};

export const useGetDefaultEmpAllowanceDeductionMutation = () => {
  return useMutation({
    mutationFn: getDefaultEmpAllowanceDeduction,
  });
};
